export enum EmailTypes {
    personal = 249,
    office = 251,
    other = 252
}